module.exports = __webpack_public_path__ + "img/JAWA-IVSweb-Logo.c436fb9a.png";